import { Injectable } from '@angular/core';
import { S3ProductPublicService } from './s3-product-public.service';

@Injectable({ providedIn: 'root' })
export class S3SrpPublicService extends S3ProductPublicService {
  // Convenção provisória: confirmar o caminho dos arquivos publicados do SRP.
  buildImageUrl(month: string, alias: string): string {
    return `${this.bucketBaseUrl}/${this.monthPrefix}${month}/srp/srp_${alias}_${month}.png`;
  }

  protected buildProbeImageUrl(month: string): string {
    return this.buildImageUrl(month, 'brasil');
  }
}
